// extracted by mini-css-extract-plugin
module.exports = {"ColorPrimary":"#243b4e"};